import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { RichTextField } from './RichTextField';
import { Plus, X } from 'lucide-react';

interface BulletsListInputProps {
  value?: string[];
  onChange: (_items: string[]) => void;
}

export const BulletsListInput: React.FC<BulletsListInputProps> = ({
  value = [],
  onChange
}) => {
  const [items, setItems] = useState<string[]>(value);

  useEffect(() => {
    setItems(value);
  }, [value]);

  const addItem = () => {
    const updatedItems = [...items, ''];
    setItems(updatedItems);
    onChange(updatedItems);
  };

  const updateItem = (index: number, newValue: string) => {
    const updatedItems = items.map((item, currentIndex) =>
      currentIndex === index ? newValue : item
    );
    setItems(updatedItems);
    onChange(updatedItems);
  };

  const removeItem = (index: number) => {
    const updatedItems = items.filter((_, currentIndex) => currentIndex !== index);
    setItems(updatedItems);
    onChange(updatedItems);
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="flex items-center gap-2"
          onClick={addItem}
        >
          <Plus className="w-4 h-4" />
          Adicionar item
        </Button>
      </div>
      {items.length === 0 ? (
        <div className="text-center py-4 text-gray-500 text-sm border-2 border-dashed border-gray-200 rounded-lg">
          Nenhum item adicionado
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((item, index) => (
            <div key={`${index}`} className="border border-gray-200 rounded-lg p-4 bg-white">
              <div className="flex items-center justify-between mb-3">
                <h4 className="text-sm font-semibold text-gray-700">Item {index + 1}</h4>
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={() => removeItem(index)}
                  className="text-red-500 hover:text-red-700 hover:bg-red-50"
                >
                  <X className="w-4 h-4" />
                </Button>
              </div>
              <RichTextField
                label=""
                value={item}
                onChange={(value: string) => updateItem(index, value)}
                placeholder="Digite o item"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

